<div class="transaction-history">
  <div class="header-row">
    <h2 i18n>Transaction History</h2>
    <div class="toggle-wrapper">
      <div class="sales-only-toggle" (click)="toggleSalesOnly()">
        <div class="label" i18n>Display only sales</div>
        <div class="toggle" [class.on]="salesOnly">
          <div></div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="loading-state">
    <app-loader></app-loader>
    <p i18n>Loading transaction history...</p>
  </div>

  <div class="transaction-wrapper" *ngIf="!isLoading && (tokenSales$ | async) as tokenSales">
    <table [cellPadding]="0" [cellSpacing]="0">
      <thead>
        <tr>
          <th i18n>Type</th>
          <th i18n>From</th>
          <th i18n>To</th>
          <th i18n>Amount</th>
          <th i18n>Txn</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let event of (tokenSales$ | async)"
          [class]="event.type | lowercase">

          <td>
            <div class="cell-inner type-label">
              <ng-container>
                <!-- {{event.platform}} -->
                <div style="display: inline-block; background: black; padding: 0.6rem; border-radius: 0.5rem; width: 2.5rem; height: 2.5rem;" *ngIf="event.platform === 'gondi'" class="marketplace-icon"><img src="/assets/gondi.svg" /></div>
                <img class="marketplace-icon" *ngIf="event.platform === 'opensea'" src="/images/opensea-logo.svg" />
                <img class="marketplace-icon" *ngIf="event.platform === 'erc721stash'" src="/images/larvalabs.svg" />
                <img class="marketplace-icon" style="background: white; padding: 0.2rem; border-radius: 0.5rem; width: 2.5rem; height: 2.5rem;" *ngIf="event.platform === 'nftfi'" src="/assets/nftfi-logo-black.svg" />
                
                <div style="display: inline-block; background: rgb(255, 255, 255); padding: 0.3rem; border-radius: 0.5rem; width: 2.5rem; height: 2.5rem;" *ngIf="event.platform === 'nftx'" class="marketplace-icon">
                  <img *ngIf="event.platform === 'nftx'" src="https://718054621-files.gitbook.io/~/files/v0/b/gitbook-legacy-files/o/assets%2F-MObsGdLeFkbdDe8_KiT%2F-MT_fnxuiPny7VoE5u32%2F-MT_nr8Nv4s1NXejtJ8j%2FNFTX_logo_on_white.svg?alt=media&token=7fb0640a-d233-4626-8361-21b1001d7935" />
                </div>
                <img class="marketplace-icon" *ngIf="event.platform === 'rarible'" src="data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjQ4IiB2aWV3Qm94PSIwIDAgNDkgNDgiIHdpZHRoPSI0OSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtLjA5NjY3OTcgMTAuNDkzMWMwLTUuNzk1MTYgNC43MTI3OTAzLTEwLjQ5MzEgMTAuNTI2MzIwMy0xMC40OTMxaDI2Ljk0NzRjNS44MTM1IDAgMTAuNTI2MyA0LjY5Nzk0IDEwLjUyNjMgMTAuNDkzMXYyNi44NjI1YzAgNS43OTUyLTQuNzEyOCAxMC40OTMxLTEwLjUyNjMgMTAuNDkzMWgtMjYuOTQ3NGMtNS44MTM1MyAwLTEwLjUyNjMyMDMtNC42OTc5LTEwLjUyNjMyMDMtMTAuNDkzMXoiIGZpbGw9IiNmZWRhMDMiLz48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0zNi4xNDE4IDIwLjAzMDhjMCAyLjI5NTMtMS4zNDEgMy40MzctMi44NDgxIDMuODMzNiAxLjgwMzguNTQwNyAzLjEwOTIgMi4wMTg5IDMuMTA5MiA0LjM2MjJ2NC4zMDIyaC02Ljg4M3YtNC4wODU5YzAtMS4yNDk4LS43MzU4LTEuNzU0NS0xLjk5MzctMS43NTQ1aC04LjE2NDd2NS44NDA0aC02Ljg4M3YtMTcuMjA4N2gxNi4zNTMxYzQuMTA2IDAgNy4zMTAyLjg4OTIgNy4zMTAyIDQuNzEwN3ptLTE2Ljc3NzIuMDk3Mmg5LjMwNXYuMDAwOGMuMDEzOS0uMDAwNS4wMjc5LS4wMDA4LjA0MTktLjAwMDguNjM5OCAwIDEuMTU4NS41MjUyIDEuMTU4NSAxLjE3MzIgMCAuNjQ3OS0uNTE4NyAxLjE3MzEtMS4xNTg1IDEuMTczMS0uMDE0IDAtLjAyOC0uMDAwMi0uMDQxOS0uMDAwN3YuMDAwN2gtOS4zMDV6IiBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=" />
                <div class="marketplace-icon" *ngIf="event.platform === 'cargo'" style="background: white; padding: 0.6rem; border-radius: 0.5rem; width: 2.5rem; height: 2.5rem;">
                  <svg xmlns="http://www.w3.org/2000/svg" style="
                  width: 25px;
                  fill: #2181e2;
                  position: relative;
                  top: -0.5rem;
                  left: -0.6rem;" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M152-80h-32v-80h32q48 0 91.5-10.5T341-204q38 19 66.5 31.5T480-160q44 0 72.5-12.5T619-204q53 23 97.5 33.5T809-160h31v80h-31q-49 0-95.5-9T622-116q-40 19-73 27t-69 8q-36 0-68.5-8T339-116q-45 18-91.5 27T152-80Zm328-160q-60 0-105-40l-45-40q-27 27-60.5 46T198-247l-85-273q-5-17 3-31t25-19l59-16v-134q0-33 23.5-56.5T280-800h100v-80h200v80h100q33 0 56.5 23.5T760-720v134l59 16q17 5 25 19t3 31l-85 273q-38-8-71.5-27T630-320l-45 40q-45 40-105 40Zm2-80q31 0 55-20.5t44-43.5l46-53 41 42q11 11 22.5 20.5T713-355l46-149-279-73-278 73 46 149q11-10 22.5-19.5T293-395l41-42 46 53q20 24 45 44t57 20ZM280-607l200-53 200 53v-113H280v113Zm201 158Z"/></svg>
                </div>
                <img class="marketplace-icon" *ngIf="event.platform === 'blur'" src="https://blur.io/favicons/180.png" />
                <img
                  class="marketplace-icon"
                  *ngIf="event.type === 'Sale' && environment.collection === 'cryptopunks-v1' && isPunksmarketNativeSale(event)"
                  src="/images/larvalabs.svg"
                  alt="PunksMarket native V1 sale" />
                <img
                  class="marketplace-icon"
                  *ngIf="event.type === 'Sale' && environment.collection === 'cryptopunks-v1' && (event.platform === 'punkv1' || event.platform === 'ethereum') && !isPunksmarketNativeSale(event)"
                  src="/assets/punkv1.svg"
                  alt="Wrapped V1 sale" />
              </ng-container>
              <span [class.shiny-claimed]="event.type === 'V1Airdrop'">
                {{ event.type === 'V1Airdrop' ? 'V1 Claimed' : (event.type === 'V2Airdrop' && environment.collection === 'cryptopunks' ? 'Airdrop' : (event.type | cc2tc)) }}
              </span>

              <a
                *ngIf="(event.type === 'V1Claimed') && environment.crossMarketplaceUrl"
                [href]="environment.crossMarketplaceUrl + '/details/' + tokenId"
                target="_blank"
                class="cross-link">
                View V1
                <svg height="10" viewBox="0 0 12 12" width="10" xmlns="http://www.w3.org/2000/svg"><path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd" fill="currentColor" /></svg>
              </a>

              <a
                *ngIf="event.type === 'V2Airdrop' && event.isCrossCollection && environment.crossMarketplaceUrl"
                [href]="environment.crossMarketplaceUrl + '/details/' + tokenId"
                target="_blank"
                class="cross-link" style="color: rgba(var(--text-color), 1) !important">
                View V2
                <svg height="10" viewBox="0 0 12 12" width="10" xmlns="http://www.w3.org/2000/svg"><path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd" fill="currentColor" /></svg>
              </a>

              <a
                *ngIf="event.type === 'V1Airdrop' && event.isCrossCollection && environment.crossMarketplaceUrl"
                [href]="environment.crossMarketplaceUrl + '/details/' + tokenId"
                target="_blank"
                class="cross-link" style="color: rgba(var(--text-color), 1) !important">
                View V1
                <svg height="10" viewBox="0 0 12 12" width="10" xmlns="http://www.w3.org/2000/svg"><path d="m4 0v2h-2v8h8v-2h2v4h-12v-12zm2 6v2h-2v-2zm2 0h-2v-2h2v-2h-2v-2h6v6h-2v-2h-2z" fill-rule="evenodd" fill="currentColor" /></svg>
              </a>

              <div
                *ngIf="event.type === 'V2Airdrop' && environment.collection !== 'cryptopunks'"
                class="info-tooltip-btn"
                tippy
                [options]="{
                  interactive: true,
                  maxWidth: 400,
                  content: v2AirdropTooltipContent,
                  placement: 'top'
                }">
                <svg xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 24 24" width="16" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
              </div>

              <ng-template *ngIf="event.fromAccount?.id === environment.flashLoanContractAddress" [ngTemplateOutlet]="flashBidIcon"></ng-template>
            </div>
          </td>

          <td>
            <div class="cell-inner">
              <a
                *ngIf="event.fromAccount && event.fromAccount.id !== ZERO_ADDRESS; else placeholderCell"
                [routerLink]="['/', 'owned']"
                [queryParams]="{ address: event.fromAccount.id}">

                <app-wallet-address [address]="event.fromAccount.id"></app-wallet-address>

                <ng-container *ngIf="event.fromAccount.id === TOKENWORKS_ADDRESS.toLowerCase()">
                  <app-marketplace-icons type="tokenworks" size="1.9rem" contextClass="tx-history"></app-marketplace-icons>
                </ng-container>
                <ng-container *ngIf="event.fromAccount.id === PUNKAUCTION_ADDRESS.toLowerCase()">
                  <app-marketplace-icons type="punkauction" size="1.9rem" contextClass="tx-history"></app-marketplace-icons>
                </ng-container>
              </a>
            </div>
          </td>

          <td>
            <div class="cell-inner">
              <a
                *ngIf="event.toAccount && event.toAccount.id !== ZERO_ADDRESS; else placeholderCell"
                [routerLink]="['/', 'owned']"
                [queryParams]="{ address: event.toAccount.id }">

                <app-wallet-address [address]="event.toAccount.id"></app-wallet-address>
                
                <ng-container *ngIf="event.toAccount.id === TOKENWORKS_ADDRESS.toLowerCase()">
                  <app-marketplace-icons type="tokenworks" size="1.9rem" contextClass="tx-history"></app-marketplace-icons>
                </ng-container>
                <ng-container *ngIf="event.toAccount.id === PUNKAUCTION_ADDRESS.toLowerCase()">
                  <app-marketplace-icons type="punkauction" size="1.9rem" contextClass="tx-history"></app-marketplace-icons>
                </ng-container>
              </a>
            </div>
          </td>

          <td>
            <div class="cell-inner value">
              <ng-container *ngIf="event.value as value; else placeholderCell">
                <ng-container *ngIf="(value | weiToEth) as price; else placeholderCell">
                  {{ price | number }}Ξ <span class="usd"><ng-container *ngTemplateOutlet="usdValue; context:{ $implicit: event }"></ng-container></span>
                </ng-container>
              </ng-container>
            </div>
          </td>

          <td>
            <div class="cell-inner">
              <a [href]="'https://etherscan.io/tx/' + (event.transactionHash)" target="_blank">
                {{ (+event.blockTimestamp * 1000) | date }}
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>


    <div class="load-more" *ngIf="hasMore">
      <button (click)="loadMore()" [disabled]="isLoading">
        {{ isLoading ? 'Loading...' : 'Load more' }}
      </button>
    </div>

  </div>

</div>

<ng-template #placeholderCell>
  <div class="placeholder">&nbsp;</div>
</ng-template>

<ng-template #usdValue let-event>
  (${{ ((event.value | weiToEth) | usd : event.usd) | formatCash }})
</ng-template>

<ng-template #flashBidIcon>
  <div 
    tippy
    [options]="{
      interactive: true,
      content: 'Canceled by owner or a delegate.xyz wallet',
      placement: 'top'
    }">
    <svg style="transform: translate(0, 0.1rem); margin-left: 0.2rem; opacity: 0.6; fill: rgba(var(--text-color), 1);" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m480-336 128-184H494l80-280H360v320h120v144ZM400-80v-320H280v-480h400l-80 280h160L400-80Zm80-400H360h120Z"/></svg>
  </div>
</ng-template>


